<template>
  <div class="sub-container">
    <v-card class="ml-3 mt-0" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">mdi-account</v-icon>All Lists</span
        >
        <v-spacer />

        <v-btn
          color="purple"
          variant="flat"
          class="btn-text mr-3"
          size="small"
          :to="{ name: 'AddList' }"
        >
          <span class="btn-text"
            ><v-icon class="mx-2">mdi-plus</v-icon>Add New List</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-card-actions>
      <span class="mt-n3 ml-6 head-sub-text">All Lists</span>
      <v-spacer />

      <v-btn
        color="#50568e"
        variant="flat"
        class="text-none"
        size="small"
        :to="{ name: 'AddList' }"
      >
        <span class="btn-text"><v-icon class="mx-2">mdi-file-plus</v-icon>Add List</span>
      </v-btn>
    </v-card-actions> -->

    <v-card variant="flat" class="ml-3">
      <v-card-actions class="ml-0">
        <v-spacer />
        <div class="search-field">
          <v-text-field
            v-model="search"
            label="Quick Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            class="mr-5"
          />
        </div>
      </v-card-actions>
      <v-data-table
        :items="lists.length > 0 ? lists : []"
        :headers="headers"
        item-value="id"
        :search="search"
        density="compact"
        :items-per-page="17"
      >
        <!-- <template #[`item.status`]="{ item }">
                    <v-chip :color="getColor(item.raw.is_subscribed)" variant="flat" size="x-small">
                        <span class="chip-text">{{
                            item.raw.is_subscribed ? "subscribed" : "unsubscribed"
                            }}</span>
                    </v-chip>
                </template> -->

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center">
            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props: tooltipProps }">
                <v-icon
                  v-bind="tooltipProps"
                  class="cursor-pointer text-primary mx-2 ml-n2"
                  @click="
                    $router.push({
                      name: 'AddList',
                      params: { id: item.raw.id },
                    })
                  "
                >
                  mdi-pencil
                </v-icon>
              </template>
            </v-tooltip>

            <v-tooltip location="bottom" text="Delete">
              <template #activator="{ props: tooltipProps }">
                <v-icon
                  v-bind="tooltipProps"
                  class="cursor-pointer text-error mx-2"
                  @click="deleteItem(item.raw.id, item.raw.name)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="loaderState" max-width="500">
      <v-card>
        <v-card-actions><v-spacer />Please Wait <v-spacer /></v-card-actions>
        <v-card-actions
          ><v-spacer />
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>

          <v-spacer />
        </v-card-actions>

        <v-progress-linear
          class="mx-2 mt-n3"
          color="teal"
          indeterminate
        ></v-progress-linear>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ListDisplayPage",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      // v.$store.dispatch("subscribers/getSubscribers");
      v.$store.dispatch("subscribers/getLists");
    });
  },

  data() {
    return {
      dialog: true,
      groups: [],
      menu: false,
      menu2: false,
      menu3: false,
      search: "",
      isValid: false,
      loadingState: false,
      screenSize: "",
      oldValue: false,

      selected: [],

      headers: [
        {
          title: "Name",
          key: "name",
        },
        { title: "No. of Subscribers", key: "num_subscribers" },
        // {
        //     title: "Type",
        //     key: "status",

        // },
        // {
        //     title: "No of Subscribers",
        //     key: "status",

        // },
        { title: "Actions", key: "actions" },
      ],
    };
  },

  computed: {
    lists() {
      return this.$store.getters["subscribers/subscribersGetters"]("Lists");
    },
    subscribers() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "subscribers"
      );
    },
    loaderState() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "loaderState"
      );
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    deleteItem(val, val2) {
      if (confirm(`Are you sure you want to delete this list: ${val2}`)) {
        this.$store.dispatch("list/deleteList", parseInt(val));
      }
    },

    getColor(val) {
      if (val) return "#46c35f";
      else return "orange";
    },
    changeAvatarColor(item) {
      // Change the color of the clicked avatar
      item.avatarProps.color = "red"; // Change to desired color
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import url("../listStyles.css");
</style>
